export default "__VITE_ASSET__059accd1__"